import { DASHBOARD_ICON } from './dashboard-icon';
import { ORG_PROFILE_ICON } from './org-profile-icon';
import { USER_MANAGEMENT_ICON } from './user-manage-icon';
import { INTEGRATIONS_ICON } from './integrations-icon';
import { ADOPTION_PACKET_ICON } from './adoption-packet-icon';
import { PROVIDERS_ICON } from './providers-icon';
import { PETSZEL_BRANDMARK_ICON } from './petszel-brandmark-icon';
import { NAVIGATION_CLOSE_ICON } from './navigation-close-icon';
import { HAMBURGER_ICON } from './hamburguer-icon';
import { CHECK_INS_ICON } from './check-ins-icon';
import { ADOPTION_LIST_ICON } from './adoption-list-icon';
import { ADOPTER_PROFILE_ICON } from './adopter-profile-icon';
import { EDIT_ICON } from './edit-icon';
import { BACK_ICON } from './back-icon';
import { EMAIL_ICON } from './email-icon';
import { UTILITY_SEARCH_ICON } from './utilities/utility-search-icon';
import { UTILITY_ARROW_DOWN_ICON } from './utilities/utility-arrow-down-icon';
import { DOG_AVATAR_ICON } from './dog-avatar-icon';
import { CAT_AVATAR_ICON } from './cat-avatar-icon';
import { UTILITY_COPY_ICON } from './utilities/utility-copy-icon';
import { CAMERA_CIRCLE_ICON } from './camera-circle-icon';
import { PLUS_ICON } from './plus-icon';
import { UTILITY_HELP_ICON } from './utilities/utility-tooltip';
import { UTILITY_DOWNLOAD_ICON } from './utilities/utlity-arrow-download';
import { UTILITY_WARNING_ICON } from "./utilities/utility-warning-icon";
import { UTILITY_CHECKMARK_ICON } from "./utilities/utility-checkmark-icon";
import { UTILITY_CLOSE_ICON } from "./utilities/utility-close-icon";
import { UTILITY_USER_ICON } from "./utilities/utility-user-icon";
import { UTILITY_MAGNIFYING_GLASS_ICON } from "./utilities/utility-magnifying-glass-icon";
import { CHARTS_ICON } from "./charts-icon";
import { ALARM_ICON } from "./alarm-icon";
import { OUTLINED_X_ICON } from "./outlined-x-icon";
import { OUTLINED_CHECK_ICON } from "./outlined-check-icon";
import {
  CHECK_INS_SELECTOR_ICON,
  CHECK_INS_STATUS_ALL_ISSUE_ICON,
  CHECK_INS_STATUS_BEHAVIORAL_ISSUE_ICON,
  CHECK_INS_STATUS_COMPLETED_ICON,
  CHECK_INS_STATUS_DEFAULT_ICON, CHECK_INS_STATUS_GENERAL_BEHAV_ISSUE_ICON, CHECK_INS_STATUS_GENERAL_ISSUE_ICON,
  CHECK_INS_STATUS_MED_BEHAV_ISSUE_ICON, CHECK_INS_STATUS_MED_GENERAL_ISSUE_ICON, CHECK_INS_STATUS_MEDICAL_ISSUE_ICON,
  CHECK_INS_STATUS_MISSED_ICON
} from "./check-ins-status/check-ins-status-icons";
import { CLOCK_ICON } from './clock-icon';

export const SVG_ICONS: Record<string, string> = {
  //General Icons
  dashboardIcon: DASHBOARD_ICON,
  orgProfileIcon: ORG_PROFILE_ICON,
  userManagementIcon: USER_MANAGEMENT_ICON,
  integrationsIcon: INTEGRATIONS_ICON,
  adoptionPacketIcon: ADOPTION_PACKET_ICON,
  providersIcon: PROVIDERS_ICON,
  checkInsIcon: CHECK_INS_ICON,
  petszelBrandmark: PETSZEL_BRANDMARK_ICON,
  navigationCloseIcon: NAVIGATION_CLOSE_ICON,
  hamburgerIcon: HAMBURGER_ICON,
  adoptionListIcon: ADOPTION_LIST_ICON,
  adopterProfileIcon: ADOPTER_PROFILE_ICON,
  editIcon: EDIT_ICON,
  backIcon: BACK_ICON,
  emailIcon: EMAIL_ICON,
  dogAvatarIcon: DOG_AVATAR_ICON,
  catAvatarIcon: CAT_AVATAR_ICON,
  cameraCircleIcon: CAMERA_CIRCLE_ICON,
  plusIcon: PLUS_ICON,
  chartsIcon: CHARTS_ICON,
  alarmIcon: ALARM_ICON,
  outlinedXIcon: OUTLINED_X_ICON,
  outlinedCheckIcon: OUTLINED_CHECK_ICON,
  clockIcon: CLOCK_ICON,
  
  // Utility Icons
  utilityCopyIcon: UTILITY_COPY_ICON,
  utilitySearchIcon: UTILITY_SEARCH_ICON,
  utilityArrowDownIcon: UTILITY_ARROW_DOWN_ICON,
  utilityHelpIcon: UTILITY_HELP_ICON,
  utilityDownloadIcon: UTILITY_DOWNLOAD_ICON,
  utilityWarningIcon: UTILITY_WARNING_ICON,
  utilityCheckmarkIcon: UTILITY_CHECKMARK_ICON,
  utilityCloseIcon: UTILITY_CLOSE_ICON,
  utilityUserIcon: UTILITY_USER_ICON,
  utilityMagnifyingGlassIcon: UTILITY_MAGNIFYING_GLASS_ICON,

  // Check-ins statuses
  checkInsStatusDefaultIcon: CHECK_INS_STATUS_DEFAULT_ICON,
  checkInsStatusMissedIcon: CHECK_INS_STATUS_MISSED_ICON,
  checkInsStatusCompletedIcon: CHECK_INS_STATUS_COMPLETED_ICON,
  checkInsStatusGeneralIssueIcon: CHECK_INS_STATUS_GENERAL_ISSUE_ICON,
  checkInsStatusMedicalIssueIcon: CHECK_INS_STATUS_MEDICAL_ISSUE_ICON,
  checkInsStatusBehavioralIssueIcon: CHECK_INS_STATUS_BEHAVIORAL_ISSUE_ICON,
  checkInsStatusMedBehavIssueIcon: CHECK_INS_STATUS_MED_BEHAV_ISSUE_ICON,
  checkInsStatusMedGeneralIssueIcon: CHECK_INS_STATUS_MED_GENERAL_ISSUE_ICON,
  checkInsStatusGeneralBehavIssueIcon: CHECK_INS_STATUS_GENERAL_BEHAV_ISSUE_ICON,
  checkInsStatusAllIssueIcon: CHECK_INS_STATUS_ALL_ISSUE_ICON,
  checkInsSelectorIcon: CHECK_INS_SELECTOR_ICON,
};
